import { useState, useContext } from "react"
import { gql, useQuery } from "@apollo/client"

import { LoaderProgressBar } from "../../../components/Loaders"

import { InputSwitch } from "primereact/inputswitch"
import { useFormikContext } from "formik"

import { UserContext } from "../../../context/userContext"

// Styles
import styles from "../../../styles/Form.module.css"

export default function HandleKioskSwitch({ disabled = false }) {
  const [kioskEnabled, setKioskEnabled] = useState(false)
  const formik = useFormikContext()
  const kioskSwitchId = "template_kiosk_switch"

  const userCtx = useContext(UserContext)

  const MICROSERVICES_BY_ENTERPRISE = gql`
    query GetMicroservices(
      $staff_id: ID!
      $staff_organization_id: ID!
      $enterprise_id: ID!
    ) {
      microservices: getMicroservicesByEnterprise(
        staff_id: $staff_id
        staff_organization_id: $staff_organization_id
        enterprise_id: $enterprise_id
      ) {
        microservices_id
        microservices_name
      }
    }
  `

  const { loading } = useQuery(MICROSERVICES_BY_ENTERPRISE, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      staff_organization_id: userCtx.session.user.organization_id,
      enterprise_id: userCtx.session.user.enterprise_id,
    },
    skip: !userCtx,
    onCompleted: (data) => {
      const microservicesList = data.microservices || []

      const isKioskEnabled = microservicesList.some(
        (microservice) => microservice.microservices_id === "10"
      )

      setKioskEnabled(isKioskEnabled)
    },
    onError: (error) => {
      setKioskEnabled(false)
      console.error(error)
    },
  })

  // Cannot fall back to 'null' because the value could be 0, which is also falsy.
  const currentValue = formik.values?.kiosk

  if (loading) return <LoaderProgressBar />

  const hideToggle =
    currentValue === -1 || currentValue === null || !kioskEnabled

  if (hideToggle) return null

  return (
    <div className={styles.field}>
      <label htmlFor={kioskSwitchId} className={styles.label}>
        Integrate with Kiosk
      </label>
      <div className={styles.description}>
        Enable this template for configuration with Kiosk forms.
      </div>
      <div>
        <InputSwitch
          inputId={kioskSwitchId}
          checked={currentValue === 1}
          disabled={disabled}
          onChange={(e) => formik.setFieldValue("kiosk", e.value ? 1 : 0)}
        />
      </div>
    </div>
  )
}
